export default __webpack_public_path__ + "static/media/Triangle Sounds Better.f0311e9d.png";